export default "__VITE_ASSET__aaaUq$bE__"